<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div *ngIf="payload?.properties" [ngClass]="{ wrap: wrapContent }">
  <div class="medical-history-print-header">
    <!-- Header -->
    <div
      class="flex flex-row medical-history-title-row"
      *ngIf="!payload.properties.hideLabel?.value && payload.properties.text?.value"
    >
      <div class="flex label-cell">
        <label class="flex">
          <span>
            <div
              style="display: inline; font-size: 17px"
              [innerHTML]="payload.properties.text?.value | tokenToDiv"
            ></div>
            <span class="required" *ngIf="payload.properties.required?.value">*</span>
          </span>
        </label>
      </div>
    </div>

    <!-- Description-->
    <div class="flex flex-row medical-history-description-row" *ngIf="payload.properties.content?.value">
      <div class="flex word-wrap mb10">
        <label class="flex subtitle">
          <span [innerHTML]="payload.properties.content?.value | tokenToDiv"></span>
        </label>
      </div>
    </div>

    <mat-divider class="medical-history-divider"></mat-divider>
  </div>

  <!-- Medical History Content -->
  <div class="medical-history-container">
    <!-- Design or Preview Mode -->
    <div class="medical-history-content">
      <div *ngFor="let category of payload.properties.items?.value; let categoryIndex = index">
        <div
          *ngIf="isCategoryVisible(category) && category.value"
          class="medical-history-category"
          [class.medical-history-category--first]="isFirstVisibleCategory(categoryIndex)"
          [class.medical-history-category--checkbox-list]="category.type === 'checkbox-list'"
          [class.medical-history-category--table]="category.type === 'table'"
          [class.medical-history-category--input-list]="category.type === 'input-list'"
        >
          <!-- <h3 class="category-title">{{ category.title || '' }}</h3> -->
          <!-- Chronic Conditions (checkbox list) -->
          <fb-emr-checkbox-list
            *ngIf="category.items && category.type === 'checkbox-list'"
            [title]="category.title"
            [items]="getCheckboxItems(category)"
            [amendmentCategory]="category.name"
            [readonly]="isDesign || isPrinting"
            [scribeIndicatorVariant]="category.title === 'Chronic Conditions' ? 'full' : 'compact'"
          >
          </fb-emr-checkbox-list>

          <!-- Input Lists like other conditions, allergies, etc. -->
          <fb-input-list
            *ngIf="category.type === 'input-list'"
            [label]="category.title"
            [fields]="category.items"
            [amendmentCategory]="category.name"
            [values]="getCategoryValues(category)"
            (valuesChange)="setCategoryValues(category, $event)"
            [addTitle]="category.addTitle"
            [populatedFrom]="'PatientNow'"
            [readonly]="isDesign || isPrinting"
            [isPrinting]="isPrinting"
            [showEmptyRowsInPrint]="isTemplatePrint"
            [isPreview]="isPreview"
            [scribeIndicatorVariant]="category.title === 'Chronic Conditions' ? 'full' : 'compact'"
            (addClick)="onAddItem(category.name)"
            (emptyRowClick)="onAddItem(category.name)"
          >
          </fb-input-list>

          <!-- Tables like medications, diagnoses, etc. -->
          <fb-emr-table
            *ngIf="category.type === 'table'"
            [title]="category.title"
            [addTitle]="category.addTitle"
            [columns]="category.items"
            [amendmentCategory]="category.name"
            [values]="getCategoryValues(category)"
            (valuesChange)="setCategoryValues(category, $event)"
            [populatedFrom]="'PatientNow'"
            [readonly]="isDesign || isPrinting"
            [isDesign]="isDesign"
            [isPrinting]="isPrinting"
            [showEmptyRowsInPrint]="isTemplatePrint"
            [isPreview]="isPreview"
            [scribeIndicatorVariant]="category.title === 'Chronic Conditions' ? 'full' : 'compact'"
            (addClick)="onAddItem(category.name)"
            (emptyRowClick)="onAddItem(category.name)"
          >
          </fb-emr-table>

          <mat-divider></mat-divider>
        </div>
      </div>

      <p *ngIf="isDesign || isPreview || (!isPrinting && !hasVisibleCategories())" class="placeholder">
        Medical history will be populated from patient records
      </p>
    </div>
  </div>

  <div
    *ngIf="payload.properties.hint?.value"
    class="hint"
    [innerHTML]="payload.properties.hint?.value | tokenToDiv"
  ></div>

  <div *ngIf="payload.properties.required?.value && isSubmitted && !isValid()" class="hint-required">
    This field is required
  </div>
</div>
